export default "__VITE_ASSET__DXV4jiUo__"